const t = "tabs", a = "tabs__tab", b = "tabs__panel", s = {
  tabs: t,
  tabs__tab: a,
  "tabs__tab--active": "tabs__tab--active",
  "tabs__tab-label": "tabs__tab-label",
  "tabs__scroll-button": "tabs__scroll-button",
  "tabs__scroll-button--left": "tabs__scroll-button--left",
  "tabs__scroll-button--right": "tabs__scroll-button--right",
  tabs__panel: b,
  "tabs__panel--active": "tabs__panel--active",
  "tabs__tab-list-wrapper": "tabs__tab-list-wrapper",
  "tabs__tab-list": "tabs__tab-list",
  "tabs--filter": "tabs--filter",
  "tabs--filter-grey": "tabs--filter-grey",
  "tabs--light": "tabs--light",
  "tabs--centered": "tabs--centered",
  "tabs--no-margin": "tabs--no-margin"
};
export {
  s as default,
  t as tabs,
  b as tabs__panel,
  a as tabs__tab
};
